import { FC, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';
import { Button, Tooltip } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { FeatureHOC, FeaturesContext, useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import s from 'pages/Clients/Clients.module.scss';
import { EXPORT_CLIENTS } from 'schemas';
import notificationService from 'services/notificationService';
import { SettingsContext } from 'settings';

export const ExportUsers: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { countryCode },
    },
  } = useContext(SettingsContext);
  const {
    data: { me },
  } = useContext(AuthContext);
  const isUsersExportAvailable = useIsFeatureAvailable('export_users');
  const { company_owner } = useContext(FeaturesContext);
  const [exportClients, { loading: isExporting }] = useLazyQuery<{
    exportUsers: string;
  }>(EXPORT_CLIENTS, { fetchPolicy: 'no-cache' });

  if (!me?.is_owner) {
    return null;
  }

  return (
    <div className={s.export}>
      <FeatureHOC
        name={t('export.csv')}
        alias="export_users"
        strategy="disable"
        tooltipPosition="bottom-right"
      >
        {!company_owner?.inn && countryCode === 'RU' ? (
          <Tooltip
            contentClassName={s.tooltip}
            content={t('clients.top.export.disable')}
          >
            <Button
              iconName="IncomeIcon"
              disabled={
                !isUsersExportAvailable ||
                (!company_owner?.inn && countryCode === 'RU')
              }
              variant="outline"
              isLoading={isExporting}
              fullWidth
              onClick={() =>
                exportClients()
                  .then((response) => {
                    if (!response.data?.exportUsers) throw 'no data';

                    window.open(response.data.exportUsers);
                  })
                  .catch(() =>
                    notificationService.info({
                      t,
                      type: 'error',
                      title: t('errors.client.export'),
                    })
                  )
              }
            >
              {t('export.csv')}
            </Button>
          </Tooltip>
        ) : (
          <Button
            iconName="IncomeIcon"
            disabled={
              !isUsersExportAvailable ||
              (!company_owner?.inn && countryCode === 'RU')
            }
            variant="outline"
            isLoading={isExporting}
            fullWidth
            onClick={() =>
              exportClients()
                .then((response) => {
                  if (!response.data?.exportUsers) throw 'no data';

                  window.open(response.data.exportUsers);
                })
                .catch(() =>
                  notificationService.info({
                    t,
                    type: 'error',
                    title: t('errors.client.export'),
                  })
                )
            }
          >
            {t('export.csv')}
          </Button>
        )}
      </FeatureHOC>
    </div>
  );
};
